export enum PROFILE_TYPES {
  CARRIER = 'CARRIER',
  DEFAULT = 'DEFAULT',
  CARRIER_TEST = 'CARRIER_TEST',
  QUOTATIONS = 'QUOTATIONS',
  ABBIAMO_TESTER = 'ABBIAMO_TESTER',
  CROWDSHIPPING = 'CROWDSHIPPING',
  GO = 'GO',
  ENTERPRISE = 'ENTERPRISE',
  LOG = 'LOG',
  DASHBOARD = 'DASHBOARD',
}